import Tippy from '@tippyjs/react/headless';
import clsx from 'clsx';
import React__default from 'react';
import { cssReset, cssWithBorders, cssPopoverArrowStyle } from './index.css.js';

const Tooltip = ({ children, tooltipContent, trigger = 'mouseenter click', style, placement = 'auto-end', withArrow = false, withBorders, interactive = true, ...tippyProps }) => (React__default.createElement(Tippy, { ...tippyProps, interactive: interactive, trigger: trigger, placement: placement, render: (args) => (React__default.createElement("div", { style: style, ...args, className: clsx('u-ds4', cssReset, {
            [cssWithBorders]: withBorders
        }) },
        withArrow && React__default.createElement("span", { className: `${cssPopoverArrowStyle} u-ds4`, "data-popper-arrow": true }),
        tooltipContent)) }, children));

export { Tooltip, Tooltip as default };
//# sourceMappingURL=index.js.map
